import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthType } from '@core/enums';
import { Translations, User } from '@core/models';
import { AuthService } from '@shared/services/auth.service';
import { ButtonType } from '../../../../shared/components/button/button.component';
import { AuthFacade } from '../../auth.facade';
import { OtpComponent } from '../otp/otp.component';

interface DialogData {
	authType: AuthType;
	user: User;
}

@Component({
	templateUrl: './delete-account.component.html',
	styleUrls: ['./delete-account.component.scss'],
	providers: [AuthFacade],
})
export class DeleteAccountComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) private readonly dialogData: DialogData,
		private readonly dialogRef: MatDialogRef<DeleteAccountComponent>,
		private readonly authFacade: AuthFacade,
		private readonly authService: AuthService
	) {
		this.translations = this.authFacade.getTranslations();
	}

	translations: Translations;
	authType: AuthType;
	user: User;

	@Output() changed = new EventEmitter();

	isLoading = false;
	description: string;
	btnPrimaryLabel: string;
	btnSecondaryLabel: string;

	readonly buttonType = ButtonType;
	readonly authTypeEnum = AuthType;

	async onBtnPrimaryClick(): Promise<void> {
		const phoneWithoutCountryCode = this.user.phone;
		const phonePrefix = this.user.phonePrefix;
		const phoneWithCountryCode = `${phonePrefix}${phoneWithoutCountryCode.substring(1)}`;

		switch (this.authType) {
			case AuthType.DELETE_ACCOUNT:
				this.authService.openAuthDialog({
					component: OtpComponent,
					phone: phoneWithoutCountryCode,
					phonePrefix,
					phoneWithCountryCode,
					authType: AuthType.DELETE_ACCOUNT,
				});

				this.dialogRef.close();

				break;
			case AuthType.DELETE_ACCOUNT_HAS_ADS:
				this.dialogRef.close();

				break;
			default:
		}
	}

	onBtnSecondaryClick(): void {
		this.dialogRef.close();
	}

	private initDeclarations(user: User): void {
		const hasPlacedAds = +user.placedAds > 0;
		this.user = user;

		this.description = hasPlacedAds ? 'n581' : 'n582';
		this.btnPrimaryLabel = hasPlacedAds ? this.translations['n563'] : this.translations['n337'];
		this.btnSecondaryLabel = hasPlacedAds ? '' : this.translations['n93'];
		this.authType = this.dialogData.authType;
	}

	ngOnInit(): void {
		this.initDeclarations(this.dialogData.user);
	}
}
